import campaignNamesForCustomer from 'main/campaignNamesAndDesc'

export const campaignNames = {
  ...campaignNamesForCustomer,
  'Ota guests': 'OTA guests',
  OTACheckedOutReview: 'OTA Review',
  OTAAfterVisit: 'OTA After last visit',
  OTACancelled: 'OTA Cancelled',
  OTAJustBooked: 'OTA Just booked',
  OTALost3Months: 'OTA Lost 3 months',
  OTALost6Months: 'OTA Lost 6 months',
  OTALost9Months: 'OTA Lost 9 months',
  OTALost12Months: 'OTA Lost 12 months',
  OTALost15Months: 'OTA Lost 15 months',
  OTALost15MonthsPlus: 'OTA Lost 15 months plus',
  OTANoShow: 'OTA No show',
  SalesAgentVirtual: 'Sales agent',
  TextBlast: 'Drip campaign',
  Custom: 'Drip campaign'
}

export const colors = [
  '#0EA5E9',
  '#14B8A6',
  '#06B6D4',
  '#22C55E',
  '#10B981',
  '#84CC16',
  '#EC4899',
  '#7CBFEB',
  '#85CBC1',
  '#82CADE',
  '#8CD496',
  '#86CBAA',
  '#B4D97B',
  '#E789B6'
]
